import InfiniteScroll from '../mixins/infinite-scoll'
import StrHelper from '../mixins/str-helper'
import CommonHelper from '../mixins/common-helper'
import CollectionPointsStore from '../store/collection-points'
import FormHelper from '../mixins/form-helper'
import NotificationHelper from '../mixins/notification-helper'
import BaseResourceHelper from '../mixins/base-resource-helper'
import NamedRouteParams from '../mixins/named-route-params'
import Datepicker from '../mixins/datepicker'
import Select from '../mixins/select'
import PagePagination from '../mixins/pagination'
import Swiper, {Controller, Navigation, Pagination, Autoplay, EffectFade} from 'swiper';
import { createApp } from 'vue';

const defaultCategory = 0;

const app = createApp({
  mixins: [
    InfiniteScroll,
    StrHelper,
    CommonHelper,
    CollectionPointsStore,
    FormHelper,
    NotificationHelper,
    BaseResourceHelper,
    NamedRouteParams,
    Datepicker,
    Select,
    PagePagination,
  ],
  data() {
    return {
      filterOpened: false, // открыт ли фильтр на мобильном

      rootPathname: window.EXCURSIONS_LIST_ROUTE,
      filters: null,
      triggeredUpdated: false, // экскурсии обновлены - нужно переинициализировать слайдеры и lazyLoad

      country: null, // страна пользователя
      currency: null, // валюта пользователя
      filtered_by_country: false,
      countries: [],
      cities: [], // список городов
      filteredCities: [], // отфильтрованные города по выбранной стране
      countries_for_filter: [],
      excursionStings: ['экскурсия', 'экскурсии', 'экскурсий'],
      attractions: [], // список достопримечательностей
      languages: [], // список языков
      categories: [], // список категорий
      movementTypes: [], // список типов передвижения

      excursions: [], // список экскурсий
      metaPagination: {}, // мета-данные пагинации

      fetchProcess: false,
      vPaginationPageNumber: 1,
      max: _.get(window._CONFIG_RULES, 'params.defaultLimit', 15),
      pagesCount: this.getPagesCount(
        +_.get(window._META_PAGINATION, 'total', 0),
        +_.get(window._CONFIG_RULES, 'params.defaultLimit', 15)
      ),

      filter: {
        category: defaultCategory,
        //country: this.country.id,
        cities: [], // выбранные города
      },

      viewFilters: [],

      routes: {
        q: '',
        country: '',
        attractions: [],
        languages: [],
        countries: [],
        cities: [],
        category: '',
        dateFrom: '',
        dateTo: '',
        movementType: '',
        page: 1
      },

      orderFilters: [
        'q',
        'country',
        'attractions',
        'languages',
        'countries',
        'cities',
        'category',
        'dateFrom',
        'dateTo',
        'movementType',
        'page',
      ],

      appliedFilters: null,
      activeAppliedFilter: null,

      orderingErrors: null,

      allDaysWeek: [],

      delaySearchByWord: null,

      attractionsSearch: '', // строка для поиска по достопримечательностям
    };
  },
  created() {
    // initialize local property from global for reactivity
    this.currency = window._USER_CURRENCY_WORLD_TOURS || {};
    this.country = window._COUNTRY || {};
    this.attractions = window._ATTRACTIONS || [];
    this.languages = window._LANGUAGES || [];
    this.countries = window._COUNTRIES || [];
    this.filtered_by_country = window._FILTERED_BY_COUNTRY || false;
    console.log('this.filtered_by_country',this.filtered_by_country)
    this.cities = window._CITIES || [];
    this.countries_for_filter = window._COUNTRIES_FOR_FILTER || [];
    this.categories = window._CATEGORIES || [];
    this.movementTypes = window._MOVEMENT_TYPES || [];
    this.filters = window._FILTERS || [];
    this.excursions = this.modifiedExcursions(window._EXCURSIONS || []);
    this.metaPagination = window._META_PAGINATION || {};

    //this.filter = window._FILTERS || [];
    console.log('_FILTER',this.filter)
    this.filter = this.newFilter();
    // this.routes = this.newFilter();

    this.initializeSelectedFilterValues();
  },
  mounted() {
    // Получаем текущий URL
    const url = window.location.href;

// Проверяем, содержит ли URL строку 'countries'
    if (url.includes('/countries')) {
      // Если содержит, вызываем метод
      this.fetchExcursions();
    }
    const el = document.getElementById('worldToursExcursions');
    el.dataset.vue = 'initialized';
    el.querySelectorAll('[data-server-render="true"]').forEach((el) => {
      el.parentNode.removeChild(el);
    });
    initSelects(el);
    // инициализация выбора дат
    const datesInput = document.getElementById('dateRange');
    initDatepicker(datesInput);
    datesInput.addEventListener('change', (evt) => {
      if (evt.target.datepicker.selectedDates.length > 1) {
        this.filter.dateFrom = evt.target.value.split(evt.target.datepicker.opts.multipleDatesSeparator)[0];
        this.filter.dateTo = evt.target.value.split(evt.target.datepicker.opts.multipleDatesSeparator)[1];
        this.filter.dateRange = `${this.filter.dateFrom} - ${this.filter.dateTo}`;
        this.onChangeFilterParams();
      } else {
        this.filter.dateFrom = '';
        this.filter.dateTo = '';
        this.filter.dateRange = '';
        this.onChangeFilterParams();
      }
    });
    // select movementType change event
    const movementTypeInput = document.getElementById('movementType');
    if (movementTypeInput) {
      movementTypeInput.addEventListener('change', (evt) => {
        this.filter.movementType = +evt.target.value;
        this.onChangeFilterParams();
      });
    }
    // открываем выпадающий список в фильтре
    this.$refs.filter.querySelectorAll('.filter__param-value').forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        let param = el.closest('.filter__param');
        document.querySelectorAll('.filter__param').forEach((p) => {
          if (p !== param) {
            p.classList.remove('opened');
          }
        });
        el.closest('.filter__param').classList.toggle('opened');
      });
    });
    // закрываем выпадающий список в фильтре
    this.$refs.filter.querySelectorAll('.filter__param-title .icomoon').forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        el.closest('.filter__param').classList.remove('opened');
      });
    });
    this.$refs.filter.querySelectorAll('.filter__param').forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.stopPropagation();
      });
    });
    document.body.addEventListener('click', (evt) => {
      document.querySelectorAll('.filter__param').forEach((p) => {
        p.classList.remove('opened');
      });
    });
    console.log('endMount')
  },
  updated () {
    if (!this.triggeredUpdated) return;
    this.triggeredUpdated = false;
    if (lazyLoad) {
      // after mounted if lazyLoad plugin is loaded we need to update it
      lazyLoad.update();
    }
    this.initSliders();
  },
  watch: {
    routes: {
      handler(val, oldVal) {
        this.changeRoute(this.buildRoute(this.orderFilters, this.routes), this.rootPathname);
      },
      deep: true
    },

    filter: {
      handler(val, oldVal) {
        this.toViewFilters(val);
      },
      deep: true
    },

    'filter.q': function(val, oldVal) {
      this.routes.q = val;
    },

    'filter.country': function(val, oldVal) {
      this.routes.country = this.country.alias;
      if (val) {
        // Обновляем список городов в зависимости от выбранной страны
        this.filteredCities = this.cities.filter(city => city.country_id === val);
        console.log('brasivaem')
        this.filter.cities = []; // сбрасываем выбранные города при смене страны
      } else {
        this.filteredCities = []; // если страна не выбрана, список городов пуст
      }
    },

    'filter.attractions':  {
      handler(val, oldVal) {
        this.routes.attractions = this.getAliasesFromCollection(this.getOrderedFilterCollection(this.attractions, val));
      },
      deep: true,
    },

    'filter.languages': {
      handler(val, oldVal) {
        this.routes.languages = this.getAliasesFromCollection(this.getOrderedFilterCollection(this.languages, val));
      },
      deep: true,
    },
    'filter.countries_for_filter': {
      handler(val, oldVal) {
        this.routes.countries = this.getAliasesFromCollection(this.getOrderedFilterCollection(this.countries_for_filter, val));
      },
      deep: true,
    },

    'filter.cities': {
      handler(val, oldVal) {
        this.routes.cities = this.getAliasesFromCollection(this.getOrderedFilterCollection(this.cities, val));
        console.log('filter.citiesWatcher',this.routes.cities)
      },
      deep: true,
    },

    'filter.category': function(val, oldVal) {
      this.routes.category = this.aliasToRoute(_.get(_.find(this.categories, ['id', +val]), 'alias'));
    },

    'filter.dateFrom': function(val, oldVal) {
      this.routes.dateFrom = this.toFormatDate(val, 'DD/MM/YYYY', 'YYYY_MM_DD');
    },

    'filter.dateTo': function(val, oldVal) {
      this.routes.dateTo = this.toFormatDate(val, 'DD/MM/YYYY', 'YYYY_MM_DD');
    },

    'filter.movementType': function(val, oldVal) {
      this.routes.movementType = this.aliasToRoute(_.get(_.find(this.movementTypes, ['id', +val]), 'alias'));
      if(!val) {
        this.selectClear('#movementType');
      }
    },

    'filter.page': function(val, oldVal) {
      this.routes.page = val;
    },

    vPaginationPageNumber(val, oldVal) {
      // Загрузка экскурсий и всего прочего при переключении страницы
      if(this.filter.page !== +val && +val > 0) {
        this.filter.page = +val;
        this.routes.page = this.filter.page;
        this.vPaginationPageNumber = this.filter.page;
        this.fetchExcursions();
      }
    },

    'metaPagination.total': function(val, oldVal) {
      this.pagesCount = this.getPagesCount(val, this.max);
    },

    'excursions': {
      handler: function(val, oldVal) {
        this.triggeredUpdated = true;
      },
      deep: true
    },
  },
  computed: {
    filteredCities() {
      return this.getFilteredCities(); // Используем метод для вычисляемого свойства
    },
    attractionsFounded() {
      if(this.attractionsSearch.length)
        return _.filter(this.attractions, (item) => (new RegExp(".*" + this.attractionsSearch + ".*", "gi")).test(_.get(item, 'title', '')));
      return this.attractions;
    },

    hasFilter() {
      let params = this.omitEmpty(_.omit(this.filter, ['page']));
      return !_.isEmpty(params) || _.get(this.filter, 'page') !== 1;
    },
  },
  methods: {
    getFilteredCities() {
      return this.filteredCities.map(city => ({
        id: city.id,
        name: city.name,
      }));
    },
    getImageUrl(image) {
      if (!image) return '';  // Если изображения нет, возвращаем пустую строку
      // Реализуйте здесь логику, которая нужна для получения URL изображения
      return '' + image;
    },
    excursionLabel(count) {
      if (count === 1) return this.excursionStings[0];
      if (count > 1 && count < 5) return this.excursionStings[1];
      return this.excursionStings[2];
    },
    filterToggle(show) {
      this.filterOpened = show;
      if (this.filterOpened) { // убираем прокрутку у самого элемента
        document.body.classList.add('js_pageOverlayOpen');
      } else {
        document.body.classList.remove('js_pageOverlayOpen');
      }
    },

    newFilter() {
      console.log('newFilter',this.country.id)
      console.log('newFilter',this.route)
      return {
        q: '',
        country: this.country.id,
        attractions: [],
        languages: [],
        countries: [],
        cities: [],
        countries_for_filter:[],
        category: defaultCategory,
        dateRange: '',
        dateFrom: '',
        dateTo: '',
        movementType: '',
        page: 1
      };
    },

    initializeSelectedFilterValues(filters = null) {
      filters = filters || window._FILTERS;
      console.log('initializeSelectedFilterValues',filters)
      let cities = _.map(_.toArray(_.get(filters, 'cities', [])), (item) => item);
      console.log('LetCities',cities)
      let dateFrom = _.get(filters, 'dateFrom', '');
      let dateTo = _.get(filters, 'dateTo', '');
      let dateRange = _.get(filters, 'dateRange', '');
      if (dateFrom.length && dateTo.length) {
        dateRange = `${dateFrom} - ${dateTo}`;
      } else {
        dateRange = '';
        dateFrom = '';
        dateTo = '';
      }

      this.filter = _.merge(this.filter, filters, {
        country:      _.get(filters, 'country') ? _.get(filters, 'country').toString() : '',
        attractions:  _.map(_.toArray(_.get(filters, 'attractions', [])), (item) => +item),
        languages:    _.map(_.toArray(_.get(filters, 'languages', [])), (item) => item),
        countries_for_filter:    _.map(_.toArray(_.get(filters, 'countries_for_filter', [])), (item) => item),
        cities:    _.map(_.toArray(_.get(filters, 'cities', [])), (item) => item),
        category:     +_.get(filters, 'category') ? +_.get(filters, 'category') : defaultCategory,
        dateRange:    dateRange,
        dateFrom:     dateFrom,
        dateTo:       dateTo,
        movementType: _.get(filters, 'movementType') ? _.get(filters, 'movementType').toString() : '',
        page:         +_.get(filters, 'page', 1)
      });

      this.vPaginationPageNumber = +_.get(filters, 'page', 1);

      console.log('FilterBeforeApply',this.filter)

      this.applyFilter(this.filter);
      this.toViewFilters(this.filter);
    },

    loadMoreExcursions() {
      // Загрузить еще страницу экскурсий
      this.filter.page += 1;
      this.routes.page = this.filter.page;
      this.vPaginationPageNumber = this.filter.page;
      this.fetchExcursions(true);
    },

    onCleanFilterParams(evt) {
      this.filter.directions = [];
      this.filter.attractions = [];
      this.filter.languages = [];
      this.filter.countries_for_filter = [];
      this.filter.cities = [];
      this.filterToggle(false);
    },

    onChoiceFilterParams(evt, force = false) {
      console.log('onChoiceFilterParams')
      if (this.isMobile && !force) {
        // ... но на мобильном ждём нажатия кнопки
        return;
      } else if (force) {
        this.filterToggle(false);
      }
      this.onChangeFilterParams();
    },
    onChoiceFilterParamsCountries(evt, force = false) {
      console.log('onChoiceFilterParams')
      if (this.isMobile && !force) {
        // ... но на мобильном ждём нажатия кнопки
        return;
      } else if (force) {
        this.filterToggle(false);
      }
      this.onChangeFilterParams();
      const filterParam = document.querySelector('.filter__param');
      filterParam.classList.remove('opened');
    },
    openFilter() {
      this.filterToggle(true);  // Метод для открытия фильтра
    },
    onChangeFilterParams(clearCategoryFilter = false) {
      // Если меняем что-то в фильтре - получаем данные
      this.delay()(() => {
        this.filterExcursions();
      }, 500);
    },

    onApplyFilters() {
      this.filterExcursions();
    },

    onCleanSteps(evt) {
      this.filter.category = 'group';
      this.filter.dateRange = '';
      this.filter.dateFrom = '';
      this.filter.dateTo = '';
      this.filter.movementType = '';
      this.filterExcursions();
    },

    onClearFilters() {
      this.filter = this.newFilter();
      setTimeout(() => {
        this.filterExcursions();
      }, 50);
    },

    filterExcursions() {
      this.filter.page = 1;
      this.routes.page = this.filter.page;
      this.vPaginationPageNumber = this.filter.page;
      this.fetchExcursions();
    },

    fetchExcursions(isMore = false) {
      console.log('fetchExcursions!')
      console.log('filters!',this.filters)
      this.fetchProcess = true;
      console.log(this.rootPathname)
      console.log(this.orderFilters)
      console.log(this.routes)
      console.log(this.buildRoute(this.orderFilters, this.routes))
      axios.get(this.rootPathname+'/'+this.buildRoute(this.orderFilters, this.routes))
        .then((response) => {
          this.metaPagination = _.get(response, 'data.metaPagination');
          // Обрабатываем экскурсии
          let excursions = _.get(response, 'data.excursions');
          this.countries = _.get(response, 'data.countries');
          this.filtered_by_country = _.get(response, 'data.filtered_by_country');
          console.log('filtered_by_country2',this.filtered_by_country)
          this.cities = _.get(response, 'data.cities');
          this.countries_for_filter = _.get(response, 'data.countries_for_filter');
          if(isMore) {
            this.pushingExcursions(excursions);
            // add page: scroll to first new element
            this.$nextTick(() => {
              this.scrollToIfNeed(document.querySelector(`#itemsList .excursions__item:nth-child(${this.excursions.length - items.length + 1})`), 50);
            });
          } else {
            this.rewriteExcursions(excursions);
          }
          // Обновляем достопримечательности
          this.attractions = _.get(response, 'data.attractions', []);
          // Обновляем языки
          this.languages = _.get(response, 'data.languages', []);
          this.countries = _.get(response, 'data.countries', []);
          this.cities = _.get(response, 'data.cities', []);
          this.countries_for_filter = _.get(response, 'data.countries_for_filter', []);

          this.applyFilter(this.getFilterParamsByRoutes());
        })
        .then(() => {
          this.fetchProcess = false;
          this.$forceUpdate();
        });
    },

    getFilterParamsByRoutes() {
      let categoryFilter = _.pick(this.filter, ['exCategory', 'exCatTypes']);
      let omitEmptyValue = function(value) {
        return (
          value === '' ||
          (_.isArray(value) && value.length === 0) ||
          value === undefined ||
          value === null ||
          (_.isString(value) && value.trim() === '')
        );
      };

      return _.pick(
        this.filter,
        _.union(_.keys(_.omitBy(this.routes, omitEmptyValue)), _.keys(_.omitBy(categoryFilter, omitEmptyValue)))
      );
    },

    getFilterParamsByFilter() {
      let filter =  _.omitBy(this.filter, function(value) {
        return (
          value === '' ||
          (_.isArray(value) && value.length === 0) ||
          value === undefined ||
          value === null ||
          (_.isString(value) && value.trim() === '')
        );
      });

      if(this.needCollectionPoint) {
        filter = _.merge(filter, {
          priceType: null
        });
      }

      if(this.needPriceType) {
        filter = _.merge(filter, {
          point: null
        });
      }

      return _.omit(filter, ['page']);
    },

    applyFilter(filter) {
      this.activeAppliedFilter = JSON.stringify(filter);
      console.log('applyFilter',this.activeAppliedFilter)
      this.toCache('appliedFilters', this.activeAppliedFilter, _.clone(filter));
    },

    pushingExcursions(excursions) {
      // Добавляем экскурсии
      this.excursions = _.union(this.excursions, this.modifiedExcursions(excursions));
    },

    rewriteExcursions(excursions) {
      // Перезаписываем экскурсии
      this.excursions = this.modifiedExcursions(excursions);
    },

    modifiedExcursions(excursions) {
      return _.map(excursions, (excursion) => {
        excursion.isOrdering = false;
        excursion.inCart = false;
        excursion.dateTour = '';
        excursion.meta = [];
        if (excursion.duration) {
          excursion.meta.push(excursion.duration);
        }
        if (excursion.movementType) {
          excursion.meta.push(excursion.movementType.name);
        }
        return excursion;
      });
    },

    getPagesCount(total, max) {
      return _.ceil(total/max);
    },

    deleteViewFilters(type, id = false) {
      if(id !== false) {
        return _.filter(this.viewFilters, (vFilter) => vFilter.type !== type && vFilter.id !== id);
      }
      return _.filter(this.viewFilters, (vFilter) => vFilter.type !== type);
    },

    toViewFilters(filter) {
      this.viewFilters = [];

      for(let prop in filter) {
        if(prop === 'q' && _.get(filter, 'q', '')) {
          this.viewFilters = this.deleteViewFilters(1);

          this.viewFilters.push({
            id: _.get(filter, 'q', ''),
            name: _.get(filter, 'q', ''),
            type: 1
          });
        }

        if(prop === 'attractions' && _.get(filter, 'attractions', [])) {
          this.viewFilters = this.deleteViewFilters(2);

          let activeAttractions = this.getOrderedFilterCollection(this.attractions, _.get(filter, 'attractions', []));
          _.forEach(activeAttractions, (attraction) => this.viewFilters.push({
            id: _.get(attraction, 'id'),
            name: _.get(attraction, 'title'),
            type: 2
          }));
        }


        if(prop === 'languages' && _.get(filter, 'languages', [])) {
          this.viewFilters = this.deleteViewFilters(3);

          let activeLanguages = this.getOrderedFilterCollection(this.languages, _.get(filter, 'languages', []));
          _.forEach(activeLanguages, (language) => this.viewFilters.push({
            id: _.get(language, 'id'),
            name: _.get(language, 'title'),
            type: 3
          }));
        }

        if(prop === 'countries_for_filter' && _.get(filter, 'countries_for_filter', [])) {
          this.viewFilters = this.deleteViewFilters(7);
          console.log('this.countries',this.countries)
          let activeCountries = this.getOrderedFilterCollection(this.countries_for_filter, _.get(filter, 'countries_for_filter', []));
          _.forEach(activeCountries, (country) => this.viewFilters.push({
            id: _.get(country, 'id'),
            name: _.get(country, 'name'),
            type: 7
          }));
        }

        if(prop === 'cities' && _.get(filter, 'cities', [])) {
          this.viewFilters = this.deleteViewFilters(8);
          console.log('this.cities',this.cities)
          let activeCities = this.getOrderedFilterCollection(this.cities, _.get(filter, 'cities', []));
          _.forEach(activeCities, (city) => this.viewFilters.push({
            id: _.get(city, 'id'),
            name: _.get(city, 'name'),
            type: 8
          }));
        }

        if(prop === 'category') {
          this.viewFilters = this.deleteViewFilters(4);
          let activeCategory = this.getActiveCategory(_.get(filter, 'category'));
          if (activeCategory) {
            this.viewFilters.push({
              id: _.get(activeCategory, 'id'),
              name: _.get(activeCategory, 'title'),
              type: 4,
            });
          }
        }

        if(prop === 'dateRange' && _.get(filter, 'dateFrom', false) && _.get(filter, 'dateTo', false)) { // todo dates
          this.viewFilters = this.deleteViewFilters(5);

          const dateFrom = _.get(filter, 'dateFrom', false);
          const dateTo = _.get(filter, 'dateTo', false);
          this.viewFilters.push({
            id: 'dateRange',
            name: dateFrom === dateTo ? dateFrom : `${dateFrom} - ${dateTo}`,
            type: 5
          });
        }

        if (prop === 'movementType' && _.get(filter, 'movementType')) {
          this.viewFilters = this.deleteViewFilters(6);
          var movementType = this.getActiveMovementType(_.get(filter, 'movementType'));
          this.viewFilters.push({
            id: _.get(movementType, 'id'),
            name: _.get(movementType, 'name'),
            type: 6
          });
        }
      }
    },

    getActiveCategory: function getActiveCategory(categoryId) {
      return categoryId !== defaultCategory ? _.find(this.categories, ['id', +categoryId]) : false;
    },

    getActiveMovementType: function getActiveMovementType(movementTypeId) {
      return _.find(this.movementTypes, ['id', +movementTypeId]);
    },

    removeViewFilter(vFilter) {
      let type = _.get(vFilter, 'type');
      switch(type) {
        case 1:
          this.viewFilters = this.deleteViewFilters(type);
          this.filter.q = '';
          break;
        case 2:
          this.viewFilters = this.deleteViewFilters(type, _.get(vFilter, 'id'));
          this.filter.attractions.splice(this.filter.attractions.indexOf(_.get(vFilter, 'id')), 1);
          break;
        case 3:
          this.viewFilters = this.deleteViewFilters(type, _.get(vFilter, 'id'));
          this.filter.languages.splice(this.filter.languages.indexOf(_.get(vFilter, 'id')), 1);
          break;
        case 4:
          this.viewFilters = this.deleteViewFilters(type, _.get(vFilter, 'id'));
          if (this.filter.category === _.get(vFilter, 'id')) {
            this.filter.category = '';
          }
          break;
        case 5:
          this.viewFilters = this.deleteViewFilters(type, 'dateRange');
          this.filter.dateRange = '';
          this.filter.dateFrom = '';
          this.filter.dateTo = '';
          break;
        case 6:
          this.viewFilters = this.deleteViewFilters(type);
          this.filter.movementType = null;
          break;
        case 7:
          this.viewFilters = this.deleteViewFilters(type, _.get(vFilter, 'id'));
          this.filter.countries_for_filter.splice(this.filter.countries_for_filter.indexOf(_.get(vFilter, 'id')), 1);
          break;
        case 8:
          this.viewFilters = this.deleteViewFilters(type, _.get(vFilter, 'id'));
          this.filter.cities.splice(this.filter.cities.indexOf(_.get(vFilter, 'id')), 1);
          break;
      }
      this.onChangeFilterParams();
    },

    getExcursionsCount(items, field = 'excursions_count') {
      return _.sumBy(items, field);
    },

    getSelectedParams(items, param) {
      // получает список выбранных параметров (для вывода количества и названий в фильтре)
      return items.filter((item) => this.filter[param].includes(item.id));
    },

    getTotalSelectedParams() {
      return this.filter.attractions.length + this.filter.languages.length;
    },

    initSliders() {
      // Инициализация или запуск/остановка слайдеров в спиксе
      document.getElementById('itemsList').querySelectorAll('.excursions__item').forEach((el) => {
        if (el.querySelectorAll('.excursions__item-image > img').length <=1) {
          // Если картинок нет или она одна - слайдер не нужен
          return;
        }
        if (el.swiperInstance && !el.swiperInstance.destroyed) {
          el.swiperInstance.destroy(true, true);
          ['.swiper', '.swiper-button-prev', '.swiper-button-next', '.swiper-pagination'].forEach((div_class) => {
            const div = el.querySelector(div_class);
            if (div) {
              div.parentNode.removeChild(div);
            }
          });
        }
        el.addEventListener('mouseenter', (evt) => {
          const autoplaySpeed = 2000;
          if (el.swiperInstance && !el.swiperInstance.destroyed) {
            // Если слайдер уже есть - запускаем
            if (!el.swiperInstance.autoplay.running) {
              el.swiperInstance.autoplay.start();
            }
          } else {
            // Если слайдер еще нет - создаем
            const elements = sliderWrap(el.querySelector('.excursions__item-image'), el.querySelectorAll('.excursions__item-image > img'), true, false);
            el.swiperInstance = new Swiper(elements.slider, {
              modules: [Controller, Navigation, Pagination, Autoplay, EffectFade],
              slidesPerView: 1,
              autoplay: {
                delay: autoplaySpeed,
              },
              loop: true,
              effect: 'fade',
              lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1,
              },
              navigation: {
                clickable: true,
                prevEl: elements.prev,
                nextEl: elements.next,
              },
            });
          }
        });
        el.addEventListener('mouseleave', (evt) => {
          if (el.swiperInstance && !el.swiperInstance.destroyed) {
            // Если слайдер уже есть - останавливаем
            if (el.swiperInstance.autoplay.running) {
              el.swiperInstance.autoplay.stop();
            }
          }
        })
      });
    },

    addToCart(evt, excursion) {
      evt.preventDefault();

      if(excursion.isOrdering) {
        return;
      }
      excursion.isOrdering = true;

      let filter = this.getFilterParamsByRoutes();
      axios
        .post('excursions/order', {
          excursionId: _.get(excursion, 'id'),
          cityId: _.get(filter, 'city'),
          collectionPointId: _.get(excursion, 'timeCollection.pointCollection.id', _.get(filter, 'point')),
          priceTypeId: _.get(filter, 'priceType'),
          dateTour: _.get(excursion, 'dateTour'),
          services: _.get(excursion, 'servicesIds', []),
        }, {
          baseURL: _.get(window._APP_PARAMS, 'baseURL')
        })
        .then((response) => {
          this.notifyByAddExcursionToCart();
          let redirectTo = _.get(response, ['data', 'redirectTo'], false);
          if(redirectTo) {
            window.location.replace(redirectTo);
          }
        })
        .catch((error) => {
          this.orderingErrors = _.get(error, ['response', 'data'], []);
        })
        .then(() => {
          excursion.isOrdering = false;
          excursion.inCart = true;
        });
    },

    getExcursionCategoryType(excursion) {
      let categoryType = null;
      _.get(excursion, 'category.types', []).forEach((type) => {
        if(!categoryType && _.filter(
          _.get(excursion, 'prices', []),
          (price) => price.ct_id === type.id
        ).length) {
          categoryType = type;
        }
      });
      return categoryType;
    },
  }
});

app.config.compilerOptions.whitespace = 'preserve';

// Mount app only after loading JSON data
window.initWorldToursExcursionsPage = ()=> {
  app.mount('#worldToursExcursions');
}
